import { makeStyles } from "@material-ui/core"

import { themeColors } from "letalkui"

const useStyles = makeStyles({
	card: {
		padding: 16,
		border: "1px solid",
		borderColor: themeColors.colors.system.gray[200],
		backgroundColor: themeColors.colors.base.white,
		transition: "border-color 0.15s ease, background-color 0.15s ease"
	},
	checkbox: {
		color: themeColors.colors.system.gray[400],
		"&.Mui-checked": {
			color: themeColors.colors.system.purple[600]
		}
	},
	payloadLink: {
		width: "fit-content",
		cursor: "pointer",
		"&:hover": {
			textDecoration: "underline"
		}
	},
	payloadLinkIcon: {
		display: "flex",
		alignSelf: "center",
		fontSize: "0.875rem",
		color: themeColors.colors.system.purple[600]
	}
})

export default useStyles
